import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviationTypeComponent } from './deviation-type.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipesModule } from '../../common';

@NgModule({
  declarations: [DeviationTypeComponent],
  imports: [CommonModule, MatTooltipModule, TranslateModule.forChild({}), PipesModule],
  exports: [DeviationTypeComponent],
})
export class DeviationTypeModule {}
